module.exports = __webpack_public_path__ + "img/HC2025-112.c46b4484.jpg";